import React from 'react';
import quote from './../assets/quote.png'
import StarRating from './StarRating';

const TestimonialCard = ({ client,clientTitle, description}) => {
  return (
    <div className="relative w-full max-w-lg p-6 py-12 bg-white border border-gray-200 shadow-sm mx-auto">
      {/* Ribbon */}
        <img
          src={quote}
          alt="Ribbon"
          className="absolute left-8 top-8 w-10 h-8"
        />

        {/* Description   */}
        
        <p className="text-gray-500 text-sm text-center justify-center mb-4 mt-10">
          "{description}"
        </p>
        {/* Client name at the center   */}

        <div className='flex justify-center mt-6'>
          <StarRating rating={5} maxStars={5} />
        </div>

        <div className='mt-6'>
          {/* Client name */}
          <div className="text-center font-semibold text-md mb-1">
            — {client}
          </div>

          {/* Client title */}
          <div className="text-center italic text-gray-500 text-sm mb-4">
            {clientTitle}
          </div>
        </div>
    </div>
  );
};

export default TestimonialCard;
